import React from 'react';
import { IconCircleDot } from '@tabler/icons-react';
import { popoverContent } from './popovers/popovercontent';
import { SudsIcons } from './sudsmarkers/sudsicons';
import { SuggestedSudsIcons } from './suggestedsudsmarkers/suggestedsudsicons';

export abstract class BaseMarkerConfig {
  abstract iconClass: string;
  abstract buttonClass: string;

  abstract getIcon(feature: any): React.ReactElement;
  abstract getCoordinates(coordinates: [number, number]): [number, number];
  abstract getPopoverContent(
    feature: any,
    handleMoreDetailsClicked?: () => void
  ): {
    title: React.ReactElement;
    details: React.ReactElement;
  };
}

export class SudsConfig extends BaseMarkerConfig {
  iconClass = 'sudsIcon';
  buttonClass = 'sudsIconButton';

  getIcon(feature: any): React.ReactElement {
    return (
      SudsIcons[feature.properties?.sudsSubType as keyof typeof SudsIcons] || SudsIcons.default
    );
  }

  getCoordinates(coordinates: [number, number]): [number, number] {
    return [coordinates[0], coordinates[1]];
  }

  getPopoverContent(feature: any): { title: React.ReactElement; details: React.ReactElement } {
    return {
      title: <popoverContent.suds.title feature={feature} />,
      details: <popoverContent.suds.details feature={feature} />,
    };
  }
}

export class SuggestedSudsConfig extends BaseMarkerConfig {
  iconClass = 'suggestedSudsIcon';
  buttonClass = 'suggestedSudsIconButton';

  getIcon(feature: any): React.ReactElement {
    return (
      SuggestedSudsIcons[feature.properties['SuDS Type'] as keyof typeof SuggestedSudsIcons] ||
      SuggestedSudsIcons.default
    );
  }

  getCoordinates(coordinates: [number, number]): [number, number] {
    return [coordinates[0], coordinates[1]];
  }

  getPopoverContent(
    feature: any,
    handleMoreDetailsClicked?: () => void
  ): { title: React.ReactElement; details: React.ReactElement } {
    return {
      title: <popoverContent.suggestedSuds.title feature={feature} />,
      details: (
        <popoverContent.suggestedSuds.details
          feature={feature}
          handleMoreDetailsClicked={handleMoreDetailsClicked}
        />
      ),
    };
  }
}

export class CsoConfig extends BaseMarkerConfig {
  iconClass = 'csoIcon';
  buttonClass = 'csoIconButton';

  getIcon(): React.ReactElement {
    return <IconCircleDot size={24} />;
  }

  getCoordinates(coordinates: [number, number]): [number, number] {
    return [coordinates[0], coordinates[1]];
  }

  getPopoverContent(feature: any): { title: React.ReactElement; details: React.ReactElement } {
    return {
      title: <popoverContent.cso.title feature={feature} />,
      details: <popoverContent.cso.details feature={feature} />,
    };
  }
}

export const markerConfig = {
  suds: new SudsConfig(),
  cso: new CsoConfig(),
  suggestedSuds: new SuggestedSudsConfig(),
};
